/* Custom Reaven — Menu drawer ad accordion.
   Dawn (global.js MenuDrawer.onSummaryClick) gestisce solo l'APERTURA dei sottomenu: la chiusura
   avviene dal pulsante "indietro", che nell'accordion è nascosto. Un tap sulla voce aperta la richiude
   nativamente (<details>), ma Dawn dopo 100ms rimette `menu-opening`, aria-expanded=true e `submenu-open`.
   Qui, quando il tap avviene su una voce già aperta, ripuliamo quello stato subito dopo. */
(function () {
  if (window.__reavenDrawerAccordion) return;
  window.__reavenDrawerAccordion = true;

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest('.menu-drawer .menu-drawer__menu details > summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (!details.hasAttribute('open')) return; // sta aprendo: ci pensa Dawn

      // Sta chiudendo: Dawn riapplica lo stato dopo 100ms, noi lo togliamo dopo.
      window.setTimeout(function () {
        if (details.hasAttribute('open')) return; // riaperto nel frattempo
        details.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
        var parent = details.closest('.submenu-open');
        if (parent) parent.classList.remove('submenu-open');
        // Chiude anche i livelli annidati rimasti aperti, così alla riapertura si riparte puliti.
        details.querySelectorAll('details[open]').forEach(function (child) {
          child.removeAttribute('open');
          child.classList.remove('menu-opening');
          var childSummary = child.querySelector(':scope > summary');
          if (childSummary) childSummary.setAttribute('aria-expanded', 'false');
        });
        details.querySelectorAll('.submenu-open').forEach(function (el) {
          el.classList.remove('submenu-open');
        });
        // Dawn (solo con prefers-reduced-motion) ha intrappolato il focus nel sottomenu: lo riporta sul drawer.
        var drawer = details.closest('details[open]');
        if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(summary);
        if (drawer && typeof window.trapFocus === 'function') window.trapFocus(drawer, summary);
      }, 160);
    },
    true
  );
})();
